var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
export function checkFrameStock(sku, rebateSize, quantity = 1) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios
            .get('/api/materials/moulding/isFrameInStock', {
            params: {
                sku,
                rebateWidth: rebateSize.width,
                rebateLength: rebateSize.length,
                quantity
            }
        });
        return data.success;
    });
}
export function checkMountStock(sku, externalSize, quantity = 1) {
    return __awaiter(this, void 0, void 0, function* () {
        if (externalSize.length * externalSize.width <= 0) {
            return false;
        }
        const { data } = yield axios
            .get('/api/materials/mountboard/isInStock', {
            params: {
                sku,
                width: externalSize.width,
                length: externalSize.length,
                quantity
            }
        });
        return data.success;
    });
}
export function checkSheetStock(sku, size, quantity = 1) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield axios.get('/api/materials/sheets/isInStock', {
                params: {
                    sku,
                    width: size.width,
                    length: size.length,
                    quantity
                }
            });
        }
        catch (e) {
            return false;
        }
        return true;
    });
}
export function checkUnitStock(sku, packSize, quantity = 1) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield axios.get('/api/materials/units/isInStock', {
                params: {
                    sku,
                    packSize,
                    quantity
                }
            });
        }
        catch (e) {
            return false;
        }
        return true;
    });
}
export function checkLengthStock(sku, packType = 'length', quantity = 1) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield axios.get('/api/materials/lengths/isInStock', {
                params: {
                    sku,
                    packType,
                    quantity
                }
            });
        }
        catch (e) {
            return false;
        }
        return true;
    });
}
